import { createFileRoute, Link } from '@tanstack/react-router';
import { AuthSplit } from '../features/auth/AuthSplit';

export const Route = createFileRoute('/_auth/signup')({
  component: SignupPage,
});

/** Placeholder — self-serve sign-up is not built yet. New agencies are onboarded manually. */
function SignupPage() {
  return (
    // The login's frame, because this is the other front door — reached on purpose, from the
    // public site, and the second place a new agency meets the product.
    <AuthSplit title="Create an account">
      <p className="text-[0.8125rem] text-ink-muted">
        Self-serve sign-up isn't available yet. Get in touch and we'll set your agency up.
      </p>
      <Link
        to="/login"
        className="mt-6 inline-block text-[0.8125rem] font-medium text-accent hover:underline"
      >
        Back to sign in
      </Link>
    </AuthSplit>
  );
}
